{
  "rangeOverflow": "Der Wert muss {maxValue} oder früher sein.",
  "rangeReversed": "Das Startdatum muss vor dem Enddatum liegen.",
  "rangeUnderflow": "Der Wert muss {minValue} oder später sein.",
  "unavailableDate": "Das ausgewählte Datum ist nicht verfügbar."
}
